goog.provide('el8.apphome.docMgr.navMenu');

goog.require('el8.uiwidget.NewActionsMenu');
goog.require('el8.practicedata.unfiledInboxes');

// TODOSIDNEYDELETE - functionality has been migrated to react
el8.apphome.docMgr.navMenu = (function() {

    return {
        init: function(docMgrMain, trigger) {
            if (this._isInit) { return; }
            this._isInit = true;
            this._docMgrMain = docMgrMain;
            this._trigger = trigger;
            this._actionsMenu = new el8.uiwidget.NewActionsMenu({
                container: $('#main-content'),
                anchorTop: $('#main-content'),
                menuId: 'apphome-nav-menu',
                width: 200
            });
            var that = this;
            el8.practicedata.unfiledInboxes.addObserver(function() {
                that.updateUnfiledDocumentCount();
            });
            el8.practicedata.unfiledInboxes.load(function() {
                var refreshOnInboxChange = function(id, action) {
                    if (action === 'CREATED' || action === 'DELETED') {
                        el8.practicedata.unfiledInboxes.thoughtfulLoad();
                    }
                };
                el8.practicedata.uploadedImages.addRealtimeObserver(refreshOnInboxChange);
                el8.practicedata.uploadedFiles.addRealtimeObserver(refreshOnInboxChange);
                el8.practicedata.incomingFileGroups.addRealtimeObserver(refreshOnInboxChange);
            }, true); // async load
        },
        updateUnfiledDocumentCount: function() {
            if (!this._isInit) { return; }
            $('.unsorted-count', this._trigger).text(el8.practicedata.unfiledInboxes.getTotalCount());
        },
        displayUnfiledInboxesMenu: function($target) {
            var that = this;
            if (!this._isInit) { return; }
            var inboxes = el8.practicedata.unfiledInboxes.all();
            var menu = inboxes.map(function(inbox) {
                return {
                    actionSafeText: '<span class="emphasis">'+inbox.getName()+'</span> '+inbox.getDisplayFax()+' ('+inbox.getCount()+')',
                    actionFn: function() {
                        that._docMgrMain.show(inbox.getId());
                    }
                };
            });
            this._actionsMenu.display($target, null, {top: 50, left: 130}, menu);
            return false;
        }
    };

})();
